import { SILHOUETTE_MARKER_PIPELINE } from './silhouette-marker.pipeline';
import { TSilhouetteMarkerModel } from './silhouette-marker.types';
import pointInPolygon from 'point-in-polygon';
import { TSilhouetteOperationOutput, TSilhouetteOperationRef } from '@monorepo/types';

export const SILHOUETTE_MARKER_MODEL = {
  createModel: (
    mode: TSilhouetteMarkerModel['mode'],
    image: string,
    areas: TSilhouetteOperationOutput[],
    parentOperations?: TSilhouetteOperationRef[],
  ): TSilhouetteMarkerModel => {
    return {
      mode,
      areas: areas.map((area) => {
        const items: TSilhouetteOperationRef[] = area.operations
          ? area.operations.map((op) => ({ id: op.id, name: op.name, uniqueId: op.uniqueId }))
          : area.operationIds.map((id) => {
              const match = parentOperations?.find((o) => o.id === id);
              return { id, name: match?.name ?? id };
            });
        return {
          id: area.silhouetteOperationId,
          coordinateByPercent: area.polygon.coordinates.map(({ x, y }) => [x, y]),
          items,
        };
      }),
      image,
    };
  },
  setActiveArea: (coordinate: [number, number], silhouetteModel: TSilhouetteMarkerModel): TSilhouetteMarkerModel => {
    return SILHOUETTE_MARKER_PIPELINE.computePoints({
      ...silhouetteModel,
      areas: silhouetteModel.areas.map((v) => {
        return {
          ...v,
          isActive: pointInPolygon(coordinate, v.coordinateByPercent),
        };
      }),
    });
  },
  selectItem: (item: TSilhouetteOperationRef, silhouetteModel: TSilhouetteMarkerModel): TSilhouetteMarkerModel => {
    const key = item.uniqueId || item.id;
    return SILHOUETTE_MARKER_PIPELINE.computePoints({
      ...silhouetteModel,
      areas: silhouetteModel.areas.map((v) => {
        const match = !!v.items.find((vi) => {
          const ref = vi as TSilhouetteOperationRef;
          return (ref.uniqueId || ref.id) === key;
        });
        return { ...v, isHidden: !match, isActive: match };
      }),
      selectedItem: item,
    });
  },
  selectIssue: <I>(issue: I, silhouetteModel: TSilhouetteMarkerModel): TSilhouetteMarkerModel => {
    if (!silhouetteModel.selectedItem) return silhouetteModel;
    return SILHOUETTE_MARKER_PIPELINE.computePoints({
      ...silhouetteModel,
      selectedIssue: issue,
    });
  },
  reset: (silhouetteModel: TSilhouetteMarkerModel): TSilhouetteMarkerModel => {
    return SILHOUETTE_MARKER_PIPELINE.computePoints({
      ...silhouetteModel,
      areas: silhouetteModel.areas.map((v) => ({
        ...v,
        isActive: false,
        isHidden: false,
      })),
      selectedItem: undefined,
      selectedIssue: undefined,
    });
  },
};
